import React from 'react';
import ArrowUpIcon from "mdi-react/ChevronTripleUpIcon";
import ArrowDownIcon from "mdi-react/ChevronTripleDownIcon";

const Indicator = ({ price, percentage, name }) => {
  const isNumber = typeof percentage === "number" && !isNaN(percentage);
  const isPositive = isNumber && percentage >= 0;

  return (
    <div className="inner-container">
      <div className="indicator_circle">
        <h3>{price}</h3>
        <h3>{name.toUpperCase()}</h3>
      </div>

      <div className="innerCircleContainer">
        <div className="line" />
        <div className="smallCircle" />
      </div>

      <div className="indicator-percentage-container">
        {isNumber && (
          <div className="percentage">
            <div className={`arrow ${isPositive ? "positiveChange" : "negativeChange"}`}>
              {isPositive ? <ArrowUpIcon size={28} /> : <ArrowDownIcon size={28} />}
            </div>
            <div className="value">{Math.abs(percentage)}%</div>
          </div>
        )}
        <div className="outerText">YoY</div>
      </div>
    </div>
  );
};

export default Indicator;
